/**
 * The Working / Build mode the user picked in the header toggle.
 *
 * Kept free of React so the API client can read it too: the client tells the
 * API which mode a request was made in (`X-App-Mode`), and the API refuses
 * recipe writes made in Working mode (YC-33).
 */
export type AppMode = 'working' | 'build';

export const APP_MODE_STORAGE_KEY = 'yeschef_app_mode';

/** Request header carrying the mode. The API's `BuildModeGuard` reads it. */
export const APP_MODE_HEADER = 'X-App-Mode';

/** `error` code the API answers a Working-mode recipe write with. */
export const WORKING_MODE_READ_ONLY_ERROR = 'WORKING_MODE_READ_ONLY';

/** Working is the default, and what anything unreadable falls back to. */
export function getStoredAppMode(): AppMode {
  try {
    const stored = localStorage.getItem(APP_MODE_STORAGE_KEY);
    return stored === 'build' || stored === 'working' ? stored : 'working';
  } catch {
    return 'working';
  }
}

/**
 * Recipes can be created, edited and deleted in Build mode only, for every
 * role (YC-33). Viewing them is open in both modes. Roles and permissions
 * still apply on top of this: Build mode lifts the block, it grants nothing.
 */
export function canEditRecipesInMode(mode: AppMode): boolean {
  return mode === 'build';
}
